import { isNil } from 'lodash';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { MetricsNames } from '@/comp/MapBuilder/MetricsNames';
import { isValueHighlighted } from '@/comp/MapBuilder/utils/utils';
import Super from '@/comp/Super';
import unitsEnum from '@/constants/unitsEnum';
import ConditionalToolTip from '@/utils/ConditionalTooltip';
import { useMeasurement } from '@/hooks/useMeasurement';
import { useValueByConnectivity } from '@/hooks/useValueByConnectivity';
import { DeviceConnectivity } from '@/constants/enums';

import { getFlowTooltip } from '../CompressorNodeWidget.utils';

interface MetricElementProps {
  metric: { name: string; value: number; unit: string };
  entity: unknown;
  connectivity: DeviceConnectivity;
}

export const MetricElement = ({ metric, entity, connectivity }: MetricElementProps) => {
  const { tunit } = useMeasurement();
  const { tcvalue, tcunit } = useValueByConnectivity();
  const { t } = useTranslation();

  return metric.name === MetricsNames.Flow ? (
    <ConditionalToolTip condition={!isNil(metric.value)} placement={'bottomLeft'} content={getFlowTooltip(entity, t)}>
      <>
        <span className={`metrics-list-item-value ${isValueHighlighted(metric.name) && 'highlighted'}`}>
          {tcvalue(metric.value, connectivity)}
        </span>
        <span className="metrics-list-item-label">
          <Trans i18nKey={tcunit(tunit(unitsEnum.m3Min), metric.value, connectivity)}>
            <Super />
          </Trans>
        </span>
      </>
    </ConditionalToolTip>
  ) : (
    <>
      <span className={`metrics-list-item-value ${isValueHighlighted(metric.name) && 'highlighted'}`}>
        {tcvalue(metric.value, connectivity)}
      </span>
      <span className="metrics-list-item-label">{tcunit(t(metric.unit), metric.value, connectivity)}</span>
    </>
  );
};
